import { useCallback, useState } from 'react';

import cross from '~/assets/icons/cross.svg';
import save from '~/assets/icons/save.svg';

import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import {
	hideModal,
	setUnsavedChanges,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { Divider } from '../Divider';
import { Input } from '../Input';
import {
	StyledButtonsContainer,
	StyledCloseButtonContainer,
	StyledContainer,
	StyledModalBody,
	StyledModalHead,
	StyledModalHeading,
	StyledModalWrapper,
	StyledSaveInfoContainer,
} from './Modal.styled';

const Modal: React.FC = () => {
	const dispatch = useLayoutDispatch();

	const vehicleName = useObservable(rage.vehicles.getLocalVehicleName());
	const [inputName, setInputName] = useState<string>('');
	const [inputDesc, setInputDesc] = useState<string>('');
	const mode = useLayoutSelector((state) => state.handling.mode);

	const handleSave = useCallback(() => {
		rage.handlingTuning
			.addPreset(inputName, inputDesc)
			.catch((err) => rage.notifications.showException(err));
		dispatch(setUnsavedChanges(false));
		dispatch(hideModal());
	}, [inputName, inputDesc]);

	useInputAction(InputAction.CommonMenuClose, () => {
		dispatch(hideModal());
	});

	return (
		<StyledModalWrapper>
			<StyledContainer>
				<StyledModalHead>
					<StyledModalHeading>
						<img src={save} />
						<Text>Сохранение настроек</Text>
					</StyledModalHeading>
					<StyledCloseButtonContainer onClick={() => dispatch(hideModal())}>
						<img width={10} height={10} src={cross} />
					</StyledCloseButtonContainer>
				</StyledModalHead>
				<Divider $direction={'horizontal'} $top={30} $bottom={30} />
				<StyledModalBody>
					<Input
						type={'text'}
						placeholder={'Придумайте название'}
						onChange={(e) => setInputName(e.target.value)}
					></Input>
					<Input
						type={'text'}
						placeholder={'Доп. информация'}
						onChange={(e) => setInputDesc(e.target.value)}
					></Input>
					<Divider $direction={'horizontal'} $top={10} $bottom={10} />
					<StyledSaveInfoContainer>
						<Text>Модель</Text>
						<Text>{vehicleName}</Text>
						<Text>Режим</Text>
						<Text style={{ textTransform: 'capitalize' }}>{mode}</Text>
					</StyledSaveInfoContainer>
				</StyledModalBody>
				<StyledButtonsContainer>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height50}
						onClick={() => dispatch(hideModal())}
					>
						<Text>Отменить</Text>
					</Button>
					<Button
						color={ButtonColors.Select}
						height={ButtonHeight.Height50}
						onClick={handleSave}
					>
						<Text>Сохранить</Text>
					</Button>
				</StyledButtonsContainer>
			</StyledContainer>
		</StyledModalWrapper>
	);
};

export { Modal };
